import Vue from 'vue'
import Router from 'vue-router'
// import Home from '@/views/Home.vue'
import SignIn from '@/views/SignIn'
import Admin from '@/views/Admin'
import EditHymn from '@/views/EditHymn'
import EditCategory from '@/views/EditCategory'
import ManageCategories from '@/views/ManageCategories'
import EditParentCategory from '@/views/EditParentCategory'
import ManageParentCategories from '@/views/ManageParentCategories'
import { store } from '@/store'
import { firebase } from '@/firebase'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    // {
    //   path: '/',
    //   name: 'home',
    //   component: Home
    // },
    {
      path: '/termsandconditions',
      name: 'termsandconditions',
      component: () => import('./views/TermsAndConditions.vue')
    },
    {
      path: '/privacy',
      name: 'privacy',
      component: () => import('./views/Privacy.vue')
    },
    {
      path: '/',
      name: 'signin',
      component: SignIn
    },
    {
      path: '/admin',
      name: 'admin',
      component: Admin
    },
    {
      path: '/edit-hymn/:hymnId',
      name: 'edit-hymn',
      component: EditHymn,
      props: true
    },
    {
      path: '/edit-hymn/',
      name: 'edit-hymn-create',
      component: EditHymn,
      props: true
    },
    {
      path: '/edit-category/:categoryId',
      name: 'edit-category',
      component: EditCategory,
      props: true
    },
    {
      path: '/edit-category/',
      name: 'edit-category-create',
      component: EditCategory,
      props: true
    },
    {
      path: '/manage-categories',
      name: 'manage-categories',
      component: ManageCategories
    },
    {
      path: '/edit-parent-category/:parentCategoryId',
      name: 'edit-parent-category',
      component: EditParentCategory,
      props: true
    },
    {
      path: '/edit-parent-category/',
      name: 'edit-parent-category-create',
      component: EditParentCategory,
      props: true
    },
    {
      path: '/manage-parent-categories',
      name: 'manage-parent-categories',
      component: ManageParentCategories
    },
  ]
})

var getUser = function () {
  return new Promise((resolve, reject) => {
    firebase.auth().onAuthStateChanged((user) => {
      //console.log("getUser: Waiting for user", user)
      if (user) {
        store.dispatch('updateUser', user)
        resolve(user)
      } else {
        reject("User Not Available")
      }
    })
  })
}
/**
 * Redirect to the sign in page if user is not logged in
 */
router.beforeEach(async function (to, from, next) {
  // check if going to signin page and call next() to proceed
  try {
    let user = await getUser();
    console.log("Found user", user.email)
    next()
  } catch (error) {
    console.log(error)
    next()
  }

  // if (to.name === 'signin') {
  //   console.log("ROUTER: going to signin")
  //   next()
  // }
  // else {
  //   try {
  //     console.log("ROUTER:", new Date(), "getting user")
  //     let user = await getUser();
  //     console.log("ROUTER:", new Date(), "got user")
  //     // check if the user is logged in
  //     console.log("ROUTER: user is logged in", user)
  //     console.log("ROUTER: going to requested page", to.name)
  //     next()
  //   } catch (error) {
  //     console.log("ROUTER: Error:", error)
  //     console.log("ROUTER: going to signin")
  //     next({ name: 'signin' })
  //   }
  // }
})

export default router